var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('van-loading',{attrs:{"type":"spinner"}},[_vm._v("\n    正在登录\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }